import { http } from './config'

export default {

  getAllOrders: () => {
    return http.get('orders')
  },

  getOrder: (id) => {
    return http.get(`orders/${id}`)
  },
  
  getOrdersByRole: (roleKey) => {
    return http.get('orders/?role=' + roleKey)
  },

  getOrdersByStatus: (params) => {
    return http.get('orders/by_status/' , {params})
  },

  getOrdersByStepSequence: (step) => {
    return http.get('orders/?step=' + step)
  },

  getProductsByOrder: (orderId) => {
    return http.get('orders/' + orderId + '/order_products')
  },

  getProductsSortedByOrder: (orderId) => {
    return http.get('orders/' + orderId + '/sorted_order_products')
  },

  getOrderHistorieByOrder: (orderId) => {
    return http.get('orders/' + orderId + '/order_histories')
  },

  getOrderErrorsByOrder: (orderId) => {
    return http.get('orders/' + orderId + '/order_errors')
  },

  updateAssembler: (assemblerParams) => {
    let usuario
    if (assemblerParams.user.user_name == '') {
      usuario = ""
    } else {
      usuario = assemblerParams.user.user_name.id
    }
    return http.put('orders/' + assemblerParams.assemblerId, {
      user_id: usuario,
      token: assemblerParams.token,
      order_priority_id: assemblerParams.priority.id,
      user_old: assemblerParams.user_old,
      order_step_id: assemblerParams.order_step.id,
      note: assemblerParams.note
      })
  },
  
  getOrdersInQuarantine: (params) => {
    return http.get('orders/quarantine/', {params})
  },

  getBayProductsOrder: (orderId) => {
    return http.get('orders/' + orderId + '/bay_products_order')
  },

  getBayProductsOrderSortedManual: (orderId) => {
    return http.get('orders/' + orderId + '/bay_products_order_sorted_manual')
  },

  sendToQuarantine: (orderId) => {
    return http.put('orders/' + orderId + '/quarantine')
  },
}
